import { Center, Flex, Logo, ProgressBar, Spacing } from "@huub-web/ui";
import type { FC, ReactNode } from "react";
import { mergeClasses } from "@huub-web/utils";

import { centerStyle, contentStyle } from "./BasePage.css";

interface BasePageProps {
  children?: ReactNode;
  delay?: number;
  variant?: "default" | "centered" | "marketing";
  logo?: boolean;
  loading?: boolean;
}

/**
 * The BasePage component is the base page component that all pages should extend.
 */
export const BasePage: FC<BasePageProps> = ({
  variant = "default",
  logo = false,
  loading,
  children,
}) => {
  return (
    <div>
      {loading && <ProgressBar variant="infinite" position="absolute" />}
      {variant === "default" && children}

      {variant === "centered" && (
        <Center className={centerStyle}>
          <Flex className={contentStyle} direction="column" gap="xl">
            {logo && <Logo />}
            {children}
          </Flex>
        </Center>
      )}

      {variant === "marketing" && (
        <Flex
          className={mergeClasses(contentStyle, centerStyle)}
          direction="column"
          gap="l"
        >
          {logo && (
            <Flex justify="flex-start">
              <Logo />
            </Flex>
          )}
          <Flex
            grow
            align="center"
            justify="center"
            direction="column"
            gap="xl"
          >
            {children}
            <Spacing height="m" />
          </Flex>
        </Flex>
      )}
    </div>
  );
};
